import { GETTER_FONT_FONT } from '@/store/modules/font/getters';

export default {
  methods: {
    allCharactersSupported(text, font) {
      // remove empty characters from text
      text = text.replace(/\s+/g, '');

      if (text.length === 0) {
        return true;
      }

      const allowedCharacters =
        this.$store.getters[GETTER_FONT_FONT](font).allowed;

      for (let i = 0; i < text.length /* Already incremented below */; ) {
        const codePoint = text.codePointAt(i);

        // character is not allowed
        if (allowedCharacters.indexOf(codePoint) === -1) {
          return false;
        }

        i += String.fromCodePoint(codePoint).length;
      }

      return true;
    }
  }
};
